import React, { PropsWithChildren } from 'react';
import './ImagesDropZone.scss';
import { useDropzone, DropzoneOptions } from 'react-dropzone';
import { ImageData } from '../../../store/labels/types';
import { connect } from 'react-redux';
import { addImageData, updateActiveImageIndex } from '../../../store/labels/actionCreators';
import { AppState } from '../../../store';
import { ProjectType } from '../../../data/enums/ProjectType';
import { PopupWindowType } from '../../../data/enums/PopupWindowType';
import { updateActivePopupType, updateProjectData, updateWindowSize } from '../../../store/general/actionCreators';
import { ProjectData } from '../../../store/general/types';
import { ImageDataUtil } from '../../../utils/ImageDataUtil';
import { sortBy } from 'lodash';
import { store } from '../../../index';
import axios, { AxiosResponse } from 'axios';
import { IPestDetectionResponse } from 'src/interfaces/IPestDetectionResponse';
import { EnvironmentUtil } from 'src/utils/EnvironmentUtil';
interface IProps {
    updateActiveImageIndexAction: (activeImageIndex: number) => any;
    addImageDataAction: (imageData: ImageData[]) => any;
    updateProjectDataAction: (projectData: ProjectData) => any;
    updateActivePopupTypeAction: (activePopupType: PopupWindowType) => any;
    projectData: ProjectData;
}

const ImagesDropZone: React.FC<IProps> = (props: PropsWithChildren<IProps>) => {
    const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
        accept: {
            'image/*': ['.jpeg', '.png']
        }
    } as DropzoneOptions);

    async function createFile(url:string, cocoImageData: any) {
        let response = await fetch(url);
        let data = await response.blob();
        let metadata = {
            type: 'image/jpeg'
        };
        // Use the exact filename from COCO data to ensure proper matching
        let fileName = cocoImageData.fileName;
        let file = new File([data], fileName, metadata);
        return file
    }



    const startEditor = (projectType: ProjectType) => {
        let queryParams = new URLSearchParams(window.location.search);
        let id = queryParams.get('pdr_id');
        axios.get(
            EnvironmentUtil.getPestDetectionGetApiUrl(id),
            {
                headers: {
                    'Content-Type': 'application/json',
                    'X-App': 'a1b6224d-db22-446d-883e-7275c7df768d'
                }
            }
        ).then((response : AxiosResponse<IPestDetectionResponse>) => {
            let image = response.data.result.cocoAnnotationData.images[0].fileUrl;
            createFile(image, response.data.result.cocoAnnotationData.images[0]).then(file => {
                const newAcceptedFiles = [file]; // Create new array instead of modifying readonly array
                if (newAcceptedFiles.length > 0) {
                    const sortedFiles = sortBy(newAcceptedFiles, (item: File) => item.name);
                    props.updateProjectDataAction({
                        ...{
                            name:response.data.result.cocoAnnotationData.images[0].fileName.split(".")[0],
                            type:null
                        },
                        type: projectType
                    });
                    props.updateActiveImageIndexAction(0);
                    props.addImageDataAction(sortedFiles.map((file: File) => ImageDataUtil
                        .createImageDataFromFileData(file)));
                    // Show import annotations popup directly since we have COCO data
                    store.dispatch(updateActivePopupType(PopupWindowType.IMPORT_ANNOTATIONS))
                }
            })
        }).catch((error) => {
            alert("Error loading pest detection data: " + error.message + "\n" +
                "Please check the URL and try again.");
                // Try to close the window, fallback to going back in history
                if(window.confirm('Go back')){
                    window.history.back();
                }else{
                    window.history.back();
                }
        });

    };

    const getDropZoneContent = () => {
        if (acceptedFiles.length === 0)
            return <>
                <input {...getInputProps()} />
                <img
                    draggable={false}
                    alt={'upload'}
                    src={'ico/box-opened.png'}
                />
                <p className='extraBold'>Drop images</p>
                <p>or</p>
                <p className='extraBold'>Click here to select them</p>
            </>;
        else if (acceptedFiles.length === 1)
            return <>
                <img
                    draggable={false}
                    alt={'uploaded'}
                    src={'ico/box-closed.png'}
                />
                <p className='extraBold'>1 image loaded</p>
            </>;
        else
            return <>
                <input {...getInputProps()} />
                <img
                    draggable={false}
                    key={1}
                    alt={'uploaded'}
                    src={'ico/box-closed.png'}
                />
                <p key={2} className='extraBold'>{acceptedFiles.length} images loaded</p>
            </>;
    };

    // const startEditorWithObjectDetection = () => startEditor(ProjectType.OBJECT_DETECTION)
    // const startEditorWithImageRecognition = () => startEditor(ProjectType.IMAGE_RECOGNITION)
    startEditor(ProjectType.OBJECT_DETECTION)
    return (
        <></>
        // <div className='ImagesDropZone'>
        //     <div {...getRootProps({ className: 'DropZone' })}>
        //         {getDropZoneContent()}
        //     </div>
        //     <div className='DropZoneButtons'>
        //         <TextButton
        //             label={'Object Detection'}
        //             isDisabled={!acceptedFiles.length}
        //             onClick={startEditorWithObjectDetection}
        //         />
        //         <TextButton
        //             label={'Image recognition'}
        //             isDisabled={!acceptedFiles.length}
        //             onClick={startEditorWithImageRecognition}
        //         />
        //     </div>
        // </div>
    )
};

const mapDispatchToProps = {
    updateActiveImageIndexAction: updateActiveImageIndex,
    addImageDataAction: addImageData,
    updateProjectDataAction: updateProjectData,
    updateActivePopupTypeAction: updateActivePopupType
};

const mapStateToProps = (state: AppState) => ({
    projectData: state.general.projectData
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImagesDropZone);
